import { useAuthContext } from '../contexts/AuthContext';

/**
 * Hook to check user roles and permissions
 * @returns {Object} Role checking utilities
 */
export const useUserRole = () => {
    const { user } = useAuthContext();

    const isAuthenticated = !!user;
    const role = user?.role;

    const isSuperAdmin = role === 'SUPER_ADMIN';
    const isAdmin = role === 'ADMIN';
    const isUser = role === 'USER';

    // Check if user has admin privileges (ADMIN or SUPER_ADMIN)
    const hasAdminPrivileges = isSuperAdmin || isAdmin;

    // Check if user can access admin features
    const canAccessAdmin = hasAdminPrivileges;

    return {
        user,
        isAuthenticated,
        role,
        isSuperAdmin,
        isAdmin,
        isUser,
        hasAdminPrivileges,
        canAccessAdmin
    };
};

export default useUserRole;
